import { normalizeRecordResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const workspaceAgentQuery = async ({ req, params }) => {
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/workspace/agents/${params.agentId}`,
		headers,
		params: {
			include:
				'model,folder,workflow.steps,schedule,projects,channels,collaborators,availabilityChangedBy,template.sourceAgent',
		},
	});
	return normalizeRecordResponse(response);
};

export const workspaceConversationQuery = async ({ req, params }) => {
	const headers = computeHeaders(req);
	return await client.apiRequest({
		url: `/workspace/agents/${params.agentId}/conversations/${params.conversationId}`,
		headers,
	});
};
